import React, {useState} from 'react';
import {useIntl} from 'react-intl';
import {ReactSelectStyled} from '../../../styles';

const isEmpty = (value) => !value || (Array.isArray(value) && value.length === 0);

const initialPick = (initialData) => {
    if (!isEmpty(initialData?.device)) return 'device';
    // Sessões anteriores gravaram group como array; ignorar para não abrir o form já travado.
    if (initialData?.group != null && !Array.isArray(initialData.group)) return 'group';
    return null;
};

const DeviceGroupSelect = ({devices, groups, initialData}) => {
    const intl = useIntl();
    const [picked, setPicked] = useState(initialPick(initialData));

    return (
        <>
            <ReactSelectStyled
                radius="9px"
                options={devices}
                name="device"
                noOptionsMessage={() => intl.formatMessage({id: 'sharedNoResultFound'})}
                placeholder={intl.formatMessage({id: 'reportChooseDevices'})}
                className="w-100"
                multiple
                isDisabled={picked === 'group'}
                onChange={(value) => setPicked(isEmpty(value) ? null : 'device')}
            />

            <ReactSelectStyled
                radius="9px"
                options={groups}
                name="group"
                noOptionsMessage={() => intl.formatMessage({id: 'sharedNoResultFound'})}
                placeholder={intl.formatMessage({id: 'reportChooseGroups'})}
                className="w-100 mt-3"
                isDisabled={picked === 'device'}
                onChange={(value) => setPicked(isEmpty(value) ? null : 'group')}
            />
        </>
    );
};

export default DeviceGroupSelect;
